import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import '../../styles/theme-toggle.css';

const ThemeToggle = ({ className = '', showLabel = true, igap=5 }) => {
  const { theme, toggleTheme, isLight, isDark } = useTheme();

  return (
    <div className={`theme-toggle-container ${className}`}>
      {showLabel && (
        <span className="theme-label" >
          <strong>{isLight ? '☀️' : '🌙'} </strong>
          <strong style={{marginLeft:igap}}>{theme === 'light' ? 'Light' : 'Dark'}</strong>
        </span>
      )}
      <button
        className={`theme-toggle ${theme}`}
        onClick={toggleTheme}
        title={`Switch to ${isLight ? 'dark' : 'light'} theme`}
        aria-label={`Switch to ${isLight ? 'dark' : 'light'} theme`}
      >
        <div className="toggle-track" style={{borderWidth:1}}>
          <div className="toggle-thumb">
            <span className="toggle-icon">
              {isLight ? '☀️' : '🌙'}
            </span>
          </div>
        </div>
      </button>
    </div>
  );
};

export default ThemeToggle;